module.exports = __webpack_public_path__ + "components/flag/static/square/cc-2f4bd6491e2447cf2f275fb9b608c4c0.svg";